import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c2ee78a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { style: {"color":"#e6a23c"} }

import { computed, ref } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import codeSelect from './codeSelect.vue'
import {
  queryCodeRel,
  getCosIdBindCode,
  customerCodeDelectSelect,
  bindARKCode
} from '@/api/overseasSales/customerCenter'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'RelationCode' }

interface codeItem {
  cosId?: string
  customerName?: string
  infoMessage?: string
  arkCodes?: {
    arkCode?: string
    infoMessage?: string
  }[]
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<codeItem>({
  arkCodes: []
})
const firstData = ref<any[]>([])
const bindCodePrev = ref('')
const emit = __emit
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const arkCode: any = []
    editForm.value.arkCodes?.forEach((item: any) => {
      if (item.arkCode) {
        arkCode.push(item.arkCode)
      }
    })
    bindARKCode({
      cosId: editForm.value.cosId,
      arkCode
    })
      .then((res) => {
        // 判断是否有修改，提示语不同
        if (bindCodePrev.value === arkCode.join(',')) {
          DcMessage.success(t('tips.activitySuccess'))
        } else {
          DcMessage.success(t('tips.PoWvhdE'))
        }
        emit('success')
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const toggle = (rows: codeItem) => {
  editForm.value = {
    cosId: rows.cosId,
    customerName: rows.customerName
  }
  visible.value = true
  fetchByCosId()
}
const disabledData = computed(() => {
  const code = editForm.value.arkCodes?.map((item) => item.arkCode)
  return code
})
// 校验code
const getQueryCodeRel = (v: any) => {
  if (v.arkCode) {
    queryCodeRel(v.arkCode).then((res) => {
      if (res.data && res.data.cosId && res.data.cosId !== editForm.value.cosId) {
        v.infoMessage = t('custom.ZDedXX', { customerName: res.data.customerName })
      } else {
        v.infoMessage = ''
      }
    })
  } else {
    v.infoMessage = ''
  }
}
// 获取客户关联的客户代码
const fetchByCosId = async () => {
  loading.value = true
  try {
    await fetchCodeBySellor()
  } catch (error) {
    console.log('getData error: ', error)
  }
  setTimeout(() => {
    getCosIdBindCode({
      cosId: editForm.value.cosId,
      pageNumber: 1,
      pageSize: 500
    })
      .then((res) => {
        if (res.data.items && res.data.items.length) {
          editForm.value.arkCodes = res.data.items
          const arkCode: string[] = []
          res.data.items.forEach((item: any) => arkCode.push(item.arkCode))
          bindCodePrev.value = arkCode.join(',')
        } else {
          editForm.value.arkCodes = [{}]
          bindCodePrev.value = ''
        }
      })
      .finally(() => {
        loading.value = false
      })
  })
}
// 获取客户负责人关联的客户代码列表
const fetchCodeBySellor = () => {
  return new Promise((resolve) => {
    customerCodeDelectSelect({
      pageNumber: 1,
      pageSize: 100,
      stage: [2, 3, 4],
      cosId: editForm.value.cosId
    }).then((res) => {
      firstData.value = res.data.items
      resolve(res.data)
    })
  })
}
const hanleAdd = () => {
  editForm.value.arkCodes?.push({})
}
const hanleDel = (index: number) => {
  editForm.value.arkCodes?.splice(index, 1)
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_CosModal = _resolveComponent("CosModal")!

  return (_openBlock(), _createBlock(_component_CosModal, {
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: _unref(t)('custom.relationCodeModalTitle'),
    width: "1000px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_spin, { spinning: loading.value }, {
        default: _withCtx(() => [
          (visible.value)
            ? (_openBlock(), _createBlock(_component_a_form, {
                key: 0,
                model: editForm.value,
                ref_key: "formRef",
                ref: formRef,
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    name: "customerName",
                    label: _unref(t)('custom.customerName'),
                    rules: [{ required: true, message: _unref(t)('common.pleaseInput') }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: editForm.value.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.customerName) = $event)),
                        disabled: true
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label", "rules"]),
                  _createVNode(_component_dc_layout_card, {
                    title: _unref(t)('custom.codeDetailTitle')
                  }, {
                    subTitle: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: hanleAdd,
                        ghost: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editForm.value.arkCodes, (item, index) => {
                        return (_openBlock(), _createBlock(_component_dc_form_item, {
                          key: index,
                          label: `${_unref(t)('custom.arkCodeTitle')}${index + 1}`,
                          span: 24
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                              _createVNode(codeSelect, {
                                label: item.arkCode,
                                "onUpdate:label": ($event: any) => ((item.arkCode) = $event),
                                allowClear: "",
                                value: item,
                                firstData: firstData.value,
                                disabledData: disabledData.value,
                                cosId: editForm.value.cosId,
                                onChange: ($event: any) => (getQueryCodeRel(item))
                              }, null, 8, ["label", "onUpdate:label", "value", "firstData", "disabledData", "cosId", "onChange"]),
                              _createVNode(_component_a_button, {
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (hanleDel(index))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _createElementVNode("p", _hoisted_2, _toDisplayString(item.infoMessage), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128)),
                      (!editForm.value.arkCodes || !editForm.value.arkCodes.length)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 0,
                            span: 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_dc_layout_empty, { type: "nothing" })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              }, 8, ["model"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["spinning"])
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})